// extracted by mini-css-extract-plugin
export default {"imageWrap":"styles_imageWrap__kvgvi","textWrap":"styles_textWrap__1Sj6-"};